module.exports = __webpack_public_path__ + "static/img/sy_fkx.5b7c656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/sy_fkx.png
// module id = snuf
// module chunks = 1